import * as React from 'react'

function SvgFunCheck(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
      <path d="M11 16a.997.997 0 01-.707-.293l-4-4a.999.999 0 111.414-1.414L11 13.586l5.293-5.293a.999.999 0 111.414 1.414l-6 6A.997.997 0 0111 16" />
    </svg>
  )
}

export default SvgFunCheck
